import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { Add as AddIcon, Remove as RemoveIcon } from '@mui/icons-material';

import { COLORS, FONT_BODY } from '../storefront/storefrontStyles';

export const MIN_QUANTITY = 1;
export const MAX_QUANTITY = 99;

// 'dark' sobre el storefront; 'light' sobre un diálogo claro (el carrito de
// la llamada).
const TONES = {
    dark: {
        text: 'white',
        disabled: 'rgba(255,255,255,0.25)',
        border: COLORS.border,
    },
    light: {
        text: 'rgba(0,0,0,0.87)',
        disabled: 'rgba(0,0,0,0.26)',
        border: 'rgba(0,0,0,0.23)',
    },
};

// Stepper 1..99 (los mismos límites que valida la API).
const QuantityStepper = ({
    value,
    onChange,
    disabled,
    size = 'medium',
    tone = 'dark',
}) => {
    const small = size === 'small';
    const colors = TONES[tone] || TONES.dark;
    const buttonSx = {
        color: colors.text,
        borderRadius: 0,
        '&.Mui-disabled': { color: colors.disabled },
    };
    const change = (next) => {
        if (next < MIN_QUANTITY || next > MAX_QUANTITY) return;
        onChange(next);
    };

    return (
        <Box
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                border: `1px solid ${colors.border}`,
                borderRadius: '6px',
                overflow: 'hidden',
                opacity: disabled ? 0.6 : 1,
            }}
        >
            <IconButton
                aria-label="Restar uno"
                size={small ? 'small' : 'medium'}
                disabled={disabled || value <= MIN_QUANTITY}
                onClick={() => change(value - 1)}
                sx={buttonSx}
            >
                <RemoveIcon fontSize="small" />
            </IconButton>
            <Typography
                aria-live="polite"
                sx={{
                    minWidth: small ? 28 : 36,
                    textAlign: 'center',
                    fontFamily: FONT_BODY,
                    fontWeight: 600,
                    fontVariantNumeric: 'tabular-nums',
                    color: colors.text,
                }}
            >
                {value}
            </Typography>
            <IconButton
                aria-label="Sumar uno"
                size={small ? 'small' : 'medium'}
                disabled={disabled || value >= MAX_QUANTITY}
                onClick={() => change(value + 1)}
                sx={buttonSx}
            >
                <AddIcon fontSize="small" />
            </IconButton>
        </Box>
    );
};

export default QuantityStepper;
